<template>
  <div>
    <div v-if="isEnabled == 0" class="enableCard">
      <div class="d-flex flex-column enableCardInner">
        <div class="title">{{ $t('gateways.ntpRecordPassive') }}</div>
        <div class="detail">{{ $t('gateways.enableNTPInfo') }}</div>
        <div class="mx-auto">
          <button
            class="btn btn-primary d-block px-12 py-3 rounded"
            @click="openDetail"
            ref="enable_button"
          >
            {{ $t('gateways.activate') }}
          </button>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- List Table -->
      <List
        :header="header"
        :data="data"
        :pagination="pagination"
        :loading="loading"
        @updatePage="updatePage"
      >
        <template v-slot:item.pools="{ item }">
          <div v-if="item.pools">
            <div v-for="(p, index) in item.pools" :key="index">
              {{ p }}
            </div>
          </div>
        </template>

        <template v-slot:item.action="{ item }">
          <ActionButton
            icon="fas fa-pencil"
            :title="$t('global.update')"
            @click.native="openDetail()"
          ></ActionButton>
        </template>
      </List>
    </div>

    <!-- Create Popup -->
    <DetailModal
      :title="$t('gateways.ntpService')"
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
    >
      <NTPCreate
        :confirmModal="confirmCreate"
        :gatewayId="gatewayId"
        @resetDetailForm="resetDetailForm"
      />
    </DetailModal>
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'
import EventBus from '@/event-bus'

export default {
  name: 'NTP',
  data() {
    return {
      loading: false,
      showDetail: false,
      confirmCreate: false,
      resetForm: false,
      data: [],
      pagination: {},
      meta: {},
      header: [
        { text: 'gateways.pools', value: 'pools' },
        { text: 'gateways.timezone', value: 'timezone' },
        { text: 'global.actions', value: 'action', size: '100px' },
      ],
    }
  },
  props: {
    gatewayId: {
      type: String,
      default: '',
    },
    isEnabled: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      if (this.isEnabled == 1) {
        this.loading = true
        ApiService.get(`packetbender/netgateways/${this.gatewayId}/ntp`)
          .then(({ data }) => {
            this.data = []
            this.data.push(data)

            this.loading = false
          })
          .catch((err) => {
            this.data = []
            this.loading = false
          })
      }
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDetail() {
      this.showDetail = true
    },
    closeDetail() {
      this.showDetail = false
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getDetail()
        EventBus.$emit('reloadGatewayDetail')
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
  },
  watch: {
    meta: {
      handler() {
        this.getDetail()
      },
      deep: true,
    },
  },
  components: {
    NTPCreate: () => import('@/components/forms/GatewayNTPCreate'),
  },
}
</script>
